import { render, staticRenderFns } from "./UserDropdown.vue?vue&type=template&id=f64b6d40&scoped=true"
import script from "./UserDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserDropdown.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./UserDropdown.vue?vue&type=style&index=0&id=f64b6d40&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f64b6d40",
  null
  
)

/* custom blocks */
import block0 from "./UserDropdown.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports